import React from 'react';
import { Button, Header } from 'semantic-ui-react';

import ListViewTable from '../../../components/ListViewTable';

const ACCOUNT = {account_id: '00D41000001PZOl', org_name: "Customer Success"};
const DIDS = [
  {dnis: '19162414358'}, 
  {dnis: '19162530756'}, 
  {dnis: '19162530757'},
];

const COLUMNS = [
  {key: 'dnis', label: "DNIS"},
];


class Review extends React.Component {
  state = {loading: false};

  render() {
    const { firstStep } = this.props;
    const { loading } = this.state;
    const { handleNextStep } = this;
    return (
      <React.Fragment>
        <Header as="h3">Review Migration for {ACCOUNT.org_name}</Header>
        <ListViewTable columns={COLUMNS} rows={DIDS} />
        <Button onClick={firstStep}>Cancel</Button>
        <Button primary loading={loading} onClick={!loading && handleNextStep}>Migrate Account</Button>
      </React.Fragment>
    );
  }

  handleNextStep = (e) => {
    e.preventDefault();
    this.setState((state) => ({...state, loading: true}));
    // TODO use backend api for this
    setTimeout(this.props.nextStep, 2000);
  };
};


export default {
  title: 'Review',
  description: 'View pending changes',
  icon: 'clipboard list',
  component: Review,
};
